import { get as _get } from 'lodash';

import { GeoCoderActions, GeoCoderActionTypes } from './geo-coder.actions';
import { GeoCoderState, initialGeoCoderState } from './geo-coder.models';

export function reducer(state = initialGeoCoderState, action: GeoCoderActions): GeoCoderState {
  switch (action.type) {
    case GeoCoderActionTypes.INIT_GEOCODER_STATE:
      return Object.assign({}, initialGeoCoderState);

    case GeoCoderActionTypes.GET_AUTOCOMPLETE_RESULTS:
      return Object.assign({}, state, {
        loading: true
      });

    case GeoCoderActionTypes.GET_AUTOCOMPLETE_RESULTS_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        predictions: _get(action, 'payload')
      });
    case GeoCoderActionTypes.GET_AUTOCOMPLETE_RESULTS_FAIL:
      return Object.assign({}, state, {
        loading: false,
        error: _get(action, 'payload')
      });
    case GeoCoderActionTypes.GET_SELECTED_ADDRESS_DETAILS:
      return Object.assign({}, state, {
        loading: true,
        userSelectedChoice: _get(action, 'payload')
      });
    case GeoCoderActionTypes.GET_SELECTED_ADDRESS_DETAILS_SUCCESS:
    case GeoCoderActionTypes.SET_FULL_ADDRESS:
      return Object.assign({}, state, {
        loading: false,
        fullAddress: _get(action, 'payload')
      });
    case GeoCoderActionTypes.GET_SELECTED_ADDRESS_DETAILS_FAIL:
      return Object.assign({}, state, {
        loading: false,
        error: _get(action, 'payload')
      });
    case GeoCoderActionTypes.SET_SELECTED_SHOP:
      return Object.assign({}, state, {
        selectedShop: _get(action, 'payload')
      });
    default:
      return state;
  }
}

export const isLoading = (state: GeoCoderState) => state.loading;
export const getUserSelectedChoice = (state: GeoCoderState) => state.userSelectedChoice;
export const getPredictions = (state: GeoCoderState) => state.predictions;
export const getfullAddress = (state: GeoCoderState) => state.fullAddress;
export const getSelectedShop = (state: GeoCoderState) => state.selectedShop;
export const getError = (state: GeoCoderState) => state.error;
